import React from 'react';

import { Stack } from '@lyearn/ui';

import Banner from './components/Banner';
import Bookmark from './components/Bookmark';
import Counter from './components/Counter';
import DateStamp from './components/DateStamp';
import Description from './components/Description';
import DueDate from './components/DueDate';
import Duration from './components/Duration';
import EventTime from './components/EventTime';
import Introduction from './components/Introduction';
import Label from './components/Label';
import Points from './components/Points';
import PrimaryActionButton from './components/PrimaryActionButton';
import SecondaryActionButton from './components/SecondaryActionButton';
import Title from './components/Title';
import { HeroProvider } from './context';
import { HeroProps } from './types';

type Props = HeroProps & React.ComponentProps<typeof Stack>;

const HeroMain: React.FC<Props> = ({ children, content, ...rest }) => {
  return <HeroProvider content={content}>{children}</HeroProvider>;
};

export {
  Banner,
  Bookmark,
  Counter,
  DateStamp,
  Description,
  DueDate,
  Duration,
  EventTime,
  Introduction,
  Label,
  HeroMain as Main,
  Points,
  PrimaryActionButton,
  SecondaryActionButton,
  Title,
};
